import axios from "../axios";
const handleLoginApi = (email, password) => {
    // console.log("hello from HandleLoginApi");
    return axios.post('/api/login', { email, password }); // nhu nay nghia "email: email input", "password: password input" de khop voi Client.email ben Nodejs
}
const getAllClients = (inputid) => {
    // su dung cu phap cua template string
    return axios.get(`/api/get-all-Clients?id=${inputid}`);
    // return axios.get('/api/get-all-Client', {
    //     data: {
    //         id: inputid
    //     }
    // });

}
const createNewClientService = (data) => {
    // console.log("hello from createNewClient Service:", DataTransfer);
    return axios.post('/api/create-new-Client', data)
}
const deleteClientService = (data) => {
    // console.log("hello from createNewClient Service:", DataTransfer);
    // return axios.delete('/api/delete-Client', data)
    return axios.delete('/api/delete-Client', {
        data: {
            id: data.id
        }
    });
}
const editClientService = (data) => {
    console.log("hello from editClientService Service:", data.id);
    return axios.put('/api/edit-Client', data);

}
export {
    handleLoginApi,
    getAllClients,
    createNewClientService,
    deleteClientService,
    editClientService
}